module.exports = __webpack_public_path__ + "static/oyez-5ac116a7b69300ba266ae96b66987742.png";